import {PlantHierarchyType, useSuiteHierarchyId, usePlantHierarchyQuery} from '@hproduce/suite-core'

import {getHierarchyNodeById} from '../../Components/Base/header/PlantSelectButton/getHierarchyNodeNameById'

/**
 * Returns the selected plant's UPM id when the current hierarchy node is a Plant,
 * otherwise undefined. For a plant node the URL hierarchyId equals its UPM id.
 */
export const useSelectedPlantUpmId = (): string | undefined => {
  const hierarchyId = useSuiteHierarchyId()
  const {data: plantHierarchy} = usePlantHierarchyQuery()

  if (!hierarchyId || !plantHierarchy) {
    return undefined
  }

  const node = getHierarchyNodeById(plantHierarchy, hierarchyId)

  return node?.type === PlantHierarchyType.Plant ? hierarchyId : undefined
}
